import React from "react";
import { Box, Typography, Stack, useTheme } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUserSlash, faUsers } from "@fortawesome/free-solid-svg-icons";
import { keyframes } from "@mui/system";

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(255, 107, 0, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 107, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 107, 0, 0);
  }
`;

const LiveAgents = ({ live, offline, total }) => {
  const theme = useTheme();

  return (
    <Box
      bgcolor="background.paper"
      borderRadius={2}
      p={3}
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      boxShadow={3}
      sx={{
        transition: "all 0.3s",
        "&:hover": { boxShadow: 6 },
      }}
    >
      {/* Title */}
      <Typography
        variant="h6"
        fontWeight="bold"
        gutterBottom
        sx={{ fontFamily: "Nunito Sans, sans-serif", color: theme.palette.text.primary }}
      >
        Live Agents
      </Typography>

      <Stack spacing={3}>
        {/* Total Agents */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <FontAwesomeIcon icon={faUsers} style={{ fontSize: 20, color: theme.palette.text.primary }} />
          <Typography
            variant="body1"
            fontWeight={600}
            sx={{ fontFamily: "Nunito Sans, sans-serif", color: theme.palette.text.primary }}
          >
            Total: {total}
          </Typography>
        </Stack>

        {/* Live Agents */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <FontAwesomeIcon icon={faUser} style={{ fontSize: 28, color: theme.palette.primary.main }} />
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ fontFamily: "Nunito Sans, sans-serif", color: theme.palette.primary.main }}
          >
            {live}
          </Typography>
          <Box
            sx={{
              width: 10,
              height: 10,
              bgcolor: theme.palette.primary.main,
              borderRadius: "50%",
              animation: `${pulse} 2s infinite ease-in-out`,
            }}
          />
        </Stack>

        {/* Offline Agents */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <FontAwesomeIcon icon={faUserSlash} style={{ fontSize: 28, color: theme.palette.secondary.main }} />
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ fontFamily: "Nunito Sans, sans-serif", color: theme.palette.secondary.main }}
          >
            {offline}
          </Typography>
          <Box
            sx={{
              width: 10,
              height: 10,
              bgcolor: theme.palette.secondary.main,
              borderRadius: "50%",
            }}
          />
        </Stack>
      </Stack>
    </Box>
  );
};

export default LiveAgents;
